<template>
  <footer class="app-footer">
    <!-- 顶部波浪分割装饰 -->
    <div v-if="!$isMobile" class="footer-wave" aria-hidden="true">
      <!--<svg viewBox="0 0 1440 120" preserveAspectRatio="none">-->
      <!--  <path d="M0,80 C180,140 420,20 720,60 C1020,100 1200,30 1440,80 L1440,120 L0,120 Z" fill="url(#footerGrad)" opacity="0.85"/>-->
      <!--  <defs>-->
      <!--    <linearGradient id="footerGrad" x1="0" y1="0" x2="1" y2="0">-->
      <!--      <stop offset="0%" stop-color="var(--default-red-color)"/>-->
      <!--      <stop offset="100%" stop-color="#2c3e50"/>-->
      <!--    </linearGradient>-->
      <!--  </defs>-->
      <!--</svg>-->
    </div>
    <div class="footer-container">
      <!-- 顶部CTA区：渐变背景与柔光按钮 -->
      <div class="footer-cta" data-aos="fade-up" v-if="false">
        <div class="cta-content">
          <h3>想进一步了解杉原美校？</h3>
          <!--<p>预约校园参观或咨询课程，获取个性化升学规划建议。</p>-->
        </div>
        <div class="cta-actions">
          <router-link to="/about" class="cta-btn primary">了解学校</router-link>
          <router-link to="/teachers" class="cta-btn outline">认识师资</router-link>
        </div>
      </div>

      <!-- 顶部区域：快速链接和信息 -->
      <div class="footer-top">
        <div class="footer-section">
          <div class="footer-logo">
            <img v-if="$isMobile" src="@/assets/logo-1.png" alt="学校LOGO">
            <img v-else src="@/assets/logo-2.png" alt="学校LOGO">
          </div>
          <p class="footer-desc">专注美术教育二十余年，以更优的美术教育成就更多学子的大学梦想。</p>
        </div>

        <div class="footer-section">
          <h3 class="footer-title">关于学校</h3>
          <ul class="footer-links">
            <li><router-link to="/about">学校简介</router-link></li>
            <li><router-link to="/teachers">师资团队</router-link></li>
            <li><router-link to="/history">历史成绩</router-link></li>
          </ul>
        </div>

        <div class="footer-section" v-if="!$isMobile">
          <!--<h3 class="footer-title">校园生活</h3>-->
          <!--<ul class="footer-links">-->
          <!--  <li><router-link to="/environment">校园环境</router-link></li>-->
          <!--  <li><router-link to="/facilities">教学设施</router-link></li>-->
          <!--  <li><router-link to="/works">学生作品</router-link></li>-->
          <!--</ul>-->
        </div>

        <div class="footer-section contact-info">
          <h3 class="footer-title">联系我们</h3>
          <ul class="contact-list">
            <!--<li><i class="fas fa-map-marker-alt"></i> 山西省长治市（示例地址）</li>-->
            <li @click="makePhone('15935527382')" class="c-black-i"><i class="fas fa-phone"></i> 张老师：15935527382</li>
            <li @click="makePhone('15584455300')" class="c-black-i"><i class="fas fa-phone"></i> 李老师：15584455300</li>
            <li @click="makePhone('15383553367')" class="c-black-i"><i class="fas fa-phone"></i> 郝老师：15383553367</li>
            <!--<li><i class="fas fa-envelope"></i> contact@example.com</li>-->
            <!--<li><i class="fas fa-clock"></i> 周一至周五 8:30-17:30</li>-->
          </ul>
        </div>
      </div>

      <!-- 底部区域：版权信息 -->
      <div class="footer-bottom">
        <div class="divider"></div>
        <div class="copyright">
          &copy; 2025 杉原美校 版权所有 | <span class="beian" @click="goBeian">晋ICP备2025061181号-2</span>
        </div>
        <div class="footer-links">
          <!--<router-link to="/privacy">隐私政策</router-link>-->
          <!--<router-link to="/terms">使用条款</router-link>-->
          <!--<router-link to="/sitemap">网站地图</router-link>-->
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    goBeian() {
      window.open("https://beian.miit.gov.cn", "_target")
    },
    makePhone(phone) {
      window.location.href = `tel:${phone}`;
    },
  }
}
</script>

<style scoped lang="scss">
.c-black-i {
  color: #000000!important;
}
.app-footer {
  background: linear-gradient(135deg, #2c3e50, #34495e);
  color: #ecf0f1;
  padding: 50px 0 0;
  font-size: 14px;
  position: relative;
}

.footer-wave { position: absolute; top: -1px; left: 0; right: 0; height: 120px; overflow: hidden; }
.footer-wave svg { width: 100%; height: 120px; display: block; }

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-cta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  background: radial-gradient(1200px 200px at 20% 0%, rgba(66,185,131,0.25), transparent),
  radial-gradient(800px 150px at 80% 0%, rgba(255,255,255,0.08), transparent);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 14px;
  padding: 22px 24px;
  margin-bottom: 26px;
}

.cta-content h3 {
  margin: 0 0 6px 0;
  font-size: 20px;
}
.cta-content p {
  margin: 0;
  color: #cfd6db;
}
.cta-actions { display: flex; gap: 12px; }
.cta-btn {
  text-decoration: none;
  padding: 10px 16px;
  border-radius: 8px;
  transition: all 0.25s ease;
}
.cta-btn.primary {
  background: linear-gradient(90deg, var(--default-red-color), #2ecc71);
  color: #fff;
  box-shadow: 0 6px 20px rgba(66,185,131,0.35);
}
.cta-btn.primary:hover { transform: translateY(-2px); box-shadow: 0 10px 28px rgba(66,185,131,0.45); }
.cta-btn.outline {
  border: 1px solid rgba(255,255,255,0.25);
  color: #ecf0f1;
}
.cta-btn.outline:hover { background: rgba(255,255,255,0.06); }

.footer-top {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-section {
  margin-bottom: 20px;
}

.footer-desc {
  //color: #cfd6db;
  color: rgba(0,0,0,0.8);
  line-height: 1.6;
  margin-top: 10px;
}

.footer-title {
  color: var(--default-red-color);
  font-size: 18px;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
}

.footer-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 2px;
  background-color: var(--default-red-color);
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: #bdc3c7;
  text-decoration: none;
  transition: all 0.3s;
  display: inline-block;
  position: relative;
}

.footer-links a::after {
  content: '';
  position: absolute;
  width: 0;
  height: 1px;
  bottom: -2px;
  left: 0;
  background-color: var(--default-red-color);
  transition: width 0.3s;
}

.footer-links a:hover {
  color: var(--default-red-color);
  transform: translateX(5px);
}

.footer-links a:hover::after {
  width: 100%;
}

.contact-info li {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.contact-list { list-style: none; padding: 0; margin: 0 0 6px 0; }
.contact-list li { margin-bottom: 10px; color: #d6dde3; }

.contact-info i {
  margin-right: 10px;
  color: var(--default-red-color);
  width: 18px;
  text-align: center;
}

/* 已移除 social-media */

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  flex-wrap: wrap;
}

.divider {
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,0.22), rgba(255,255,255,0));
  margin-bottom: 10px;
}

.footer-logo {
  width: 100%;
  padding-top: 18px;

  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
}

.copyright {
  color: #7f8c8d;
  margin: 10px 0;
}
.beian {
  cursor: pointer;
  //color: #cfe7d8;
  color: var(--default-red-color);
}
.beian:hover { color: var(--default-red-color); }

.footer-bottom .footer-links {
  display: flex;
  gap: 20px;
}

.footer-bottom a {
  color: #7f8c8d;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-bottom a:hover {
  color: var(--default-red-color);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer-cta {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
    gap: 12px;
  }
  .cta-actions { flex-direction: column; }
  .cta-btn { text-align: center; padding: 12px 14px; }
  .footer-top {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  .footer-section { min-width: 0; }
  .footer-logo { width: 70%; margin: 0 auto; }
  .footer-title { font-size: 16px; margin-bottom: 12px; }
  .footer-links li { margin-bottom: 10px; }
  .footer-links a { padding: 6px 0; display: inline-block; }

  .footer-bottom {
    flex-direction: column;
    text-align: center;
  }

  .footer-bottom .footer-links {
    justify-content: center;
    margin-top: 15px;
  }
}

@media (max-width: 480px) {
  .footer-top {
    grid-template-columns: 1fr;
  }

  .footer-section {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 0 6px;
  }

  .footer-title::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .footer-links a:hover {
    transform: none;
  }

  .social-media {
    justify-content: center;
  }

  .footer-logo {
    width: 70%;
    padding-top: 18px;
  }

  /* 提升移动端触控面积与留白 */
  .social-icon { width: 44px; height: 44px; font-size: 22px; }
  .app-footer { padding-top: 36px; }
}
</style>
